export default __webpack_public_path__ + "static/media/icoLoading-2.49617747.svg";